import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { resendPaymentNotification } from "../../app/voucherSlice";
import Alert from "../Alerts/Alert";
import { useTranslation } from "react-i18next";

const AcceptanceTutorial = () => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();
    const chosenPaymentId = useAppSelector(state => state.voucher.chosenPaymentId);

    const [resendingNotification, setResendingNotification] = useState(false);

    const onResentPaymentNotification = () => {
        if (resendingNotification)
            return;

        dispatch(resendPaymentNotification(chosenPaymentId));
        setResendingNotification(true);
        setTimeout(() => { setResendingNotification(false) }, 5000);
    }

    return (
        <div className="tutorial__container">
            <div className="tutorial__description">
                <div className="tutorial__step">
                    <span className="tutorial__step-number">1</span>
                    <p>{t("tutorial.step1")}<span className="semi-bold">MyTicket®</span></p>
                </div>
                <div className="tutorial__step">
                    <span className="tutorial__step-number">2</span>
                    <p>{t("tutorial.step2")}</p>
                </div>
            </div>
            <div className="tutorial__resend">
                <p>{t("tutorial.didNotReceive")}</p>
                <button disabled={resendingNotification} onClick={onResentPaymentNotification} type="button" className="link">
                    {t("tutorial.resend")}
                </button>
                {resendingNotification && <Alert message={t("tutorial.resendAlert")} type='success' />}
            </div>
            <div className="tutorial__alert">
                <div className="tutorial__alert-title">
                    <img src="assets/icons/alert-triangle.svg" alt="" />
                    <h4>{t("tutorial.important")}</h4>
                </div>
                <p>
                    {t("tutorial.importantDescriptionPt1")}
                    <span className="semi-bold">Ticket Restaurant Mobile®</span>
                    {t("tutorial.importantDescriptionPt2")}
                </p>
            </div>
        </div>
    );
};

export default AcceptanceTutorial;
